import axios, { AxiosError, AxiosInstance } from 'axios';
import { api } from '@compassdigital/foodworks.api.ts';
import { isDisabledUserError, isLoginAuthRequest } from '@/util/AuthUtil';

const registeredAxiosInstances = new Set<AxiosInstance>();

let disabledSessionPromise: Promise<void> | null = null;

function handleDisabledSessionError(): Promise<void> {
  if (!disabledSessionPromise) {
    disabledSessionPromise = import('@/store/modules/lifecycle')
      .then(({ default: LifecycleModule }) => LifecycleModule.handleDisabledSession())
      .finally(() => {
        disabledSessionPromise = null;
      });
  }

  return disabledSessionPromise;
}

function onResponseError(error: AxiosError): Promise<never> {
  if (isDisabledUserError(error) && !isLoginAuthRequest(error)) {
    return handleDisabledSessionError().then(() => Promise.reject(error));
  }

  return Promise.reject(error);
}

function registerInterceptor(axiosInstance: AxiosInstance): void {
  if (registeredAxiosInstances.has(axiosInstance)) {
    return;
  }

  registeredAxiosInstances.add(axiosInstance);
  axiosInstance.interceptors.response.use(response => response, onResponseError);
}

function getAxiosInstances(): AxiosInstance[] {
  const instances: AxiosInstance[] = [axios, api];

  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
    const sdkAxios = require('@compassdigital/foodworks.ts.sdk/node_modules/axios');
    const sdkDefault: AxiosInstance = sdkAxios.default || sdkAxios;

    if (sdkDefault && sdkDefault !== axios && !instances.includes(sdkDefault)) {
      instances.push(sdkDefault);
    }
  } catch {
    //
  }

  return instances;
}

export default function initApiInterceptors(): void {
  getAxiosInstances().forEach(registerInterceptor);
}
